import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../../shared/services/api.service';
import {error} from '@angular/compiler/src/util';

@Component({
    selector: 'contact-page',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ContactPageComponent implements OnInit {
    apiLoaded: Observable<boolean>;
    contactForm: FormGroup;

    constructor(public formBuilder: FormBuilder, public apiService: ApiService, public toastService: ToastrService) {
    }

    ngOnInit() {
        this.contactForm = this.formBuilder.group({
            name: ['', Validators.required],
            email: ['', Validators.compose([Validators.required])],
            phone: ['', Validators.required],
            message: ['', Validators.required]
        });
    }

    public onContactFormSubmit(values: any): void {
        if (this.contactForm.valid) {
            this.apiService.addContact(values['name'], values['email'], values['phone'], values['message']).subscribe(data => {
                this.toastService.success('Thank you for reaching out! Our team will get in touch with you shortly.');
                this.contactForm.reset();
            }, err => {
                this.toastService.error('There is some issue. Please react us directly on 8448997281');
            });
        }
    }
}
